import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

export const StepContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 61px;
  margin-left: ${({ ml }) => ml || '0px'};
`;

export const WrapperCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  width: 30px;
  border-radius: 100px;
  border: ${({ borderColor }) => `1px solid ${borderColor || 'black'}`};
  background: ${({ background }) => background || 'none'};
  z-index: 10;
`;

export const Circle = styled.div`
  height: 22px;
  width: 22px;
  border-radius: 100px;
  background: ${({ background }) => background || 'black'};
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LineRight = styled.div`
  width: 40px;
  height: 2px;
  top: 13px;
  margin-left: 35px;
  background: ${({ showLine }) => showLine && 'white'};
  position: absolute;
  z-index: 0;
`;
